import styled from 'styled-components';

export const ModalWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 30px;
    height: 100%;
`;

export const ModalRow = styled.div`
  margin: 20px 0;
`;

export const ButtonWrapper = styled.div`
  display: flex;
`;

export const WarningText = styled.p`
    color: red;
    font-weight: bold;
    margin: 0;
`;



// WEBPACK FOOTER //
// ./app/components/linked-course-modal/styled.js